const ApiConfig = {
    apiUrl: "https://b2b-api.finekra.com/api"
};

// 2. STAGING KONTROLÜ
if (typeof window !== 'undefined' && window.location.hostname === 'staging-b2b-panel.finekra.com') {
    ApiConfig.apiUrl = "https://staging-b2b-api.finekra.com/api";
}


module.exports = ApiConfig; 
